import { Avatar, Style } from "@dicebear/core";
import definition from "@dicebear/styles/glass.json" with { type: "json" };
import { useMemo } from "react";

const colors = [
  "9380FF",
  "FF8080",
  "FFCD80",
  "80FFAD",
  "80DEFF",
  "FFF180",
  "86B4F8",
  "8AF4EA",
  "9EE699",
  "8DBFF1",

  "0082DB",
  "684DFF",
  "FF4D4D",
  "FFB84D",
  "4DFF8C",
  "4DD1FF",
  "FFEB4D",
  "5696F5",
  "5BF0E1",
  "78DC70",
];

const glass = new Style(definition);

const useAvatar = (seed: string) => {
  const svg = useMemo(() => {
    if (!seed) return null;

    const avatar = new Avatar(glass, {
      seed,
      backgroundColor: colors,
    });
    return avatar.toDataUri();
  }, [seed]);

  return svg;
};

export default useAvatar;
